"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.H3 = void 0;
const Box_1 = require("./Box");
exports.H3 = Box_1.Box.withComponent('h3');

//# sourceMappingURL=H3.js.map
